import { BaseOptionType } from '@rc-component/select/lib/Select';
import { AntSelectPropsGeneric, AntSelectValue } from 'controls/react/ant/ant-select/types';

export function getValueField<VT extends AntSelectValue, OptionType extends BaseOptionType>(
	props: AntSelectPropsGeneric<VT, OptionType>,
) {
	return props.fieldNames?.value ?? 'value';
}
